import { Component, OnInit } from '@angular/core';
import { debug } from 'util';
import { BaseService } from '../../shared-service/base.service';
import { WindowRef } from '../../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-fontbox',
  templateUrl: './fontbox.component.html',
  styleUrls: ['./fontbox.component.css']
})
export class FontboxComponent implements OnInit {
  measureUnit: string = "px";
  minSize: number = 1;
  minStyleSize: number = 10;
  maxSize: number = 6;
  maxStyleSize: number = 14.5;
  startSize: number = 1;
  startStyleSize: number = 10;
  stepSize: number = 1;
  stepStyleSize: number = 2;
  styleSize: number = 0;
  newStyleSize: number = 0;
  myObjName: string = '';
  constructor(public bs: BaseService ,private winRef: WindowRef) { }

  ngOnInit() {
  }


  increaseFontSize(e:any, t:any) {
    try {
      if (this.winRef.nativeWindow.document.body) {
        var n = this.searchTags(this.winRef.nativeWindow.document.body.childNodes, 0),
          a = t / 10;
        for (var i = 0; i < n.length; i++)
        if (this.myObjName = n[i].nodeName,"#text" != this.myObjName && "HTML" != this.myObjName && "HEAD" != this.myObjName && "TITLE" != this.myObjName && "STYLE" != this.myObjName && "SCRIPT" != this.myObjName && "BR" != this.myObjName && "TBODY" != this.myObjName && "#comment" != this.myObjName && "FORM" != this.myObjName && "NOSCRIPT" != this.myObjName) {
          if ("INPUT" == this.myObjName) continue;
            this.styleSize = parseInt(window.getComputedStyle(n[i], null).fontSize), 
            isNaN(this.styleSize) && n[i].currentStyle && (this.styleSize = parseInt(n[i].currentStyle.fontSize)), isNaN(this.styleSize) 
            && (this.styleSize = this.startStyleSize), 
            (this.styleSize > this.minStyleSize && this.styleSize < this.maxStyleSize || this.styleSize == this.minStyleSize && t > 0 || this.styleSize == this.maxStyleSize && 0 > t) 
            && (this.newStyleSize = this.styleSize + a * this.styleSize, n[i].style.fontSize = this.newStyleSize + this.measureUnit)
        }
      }
    } catch (l) { }
    $('.jcarousel-control-next').removeClass('inactive');
  }

  decreaseFontSize(e:any, t:any) {
    try {
      if (this.winRef.nativeWindow.document.body) {
        var n = this.searchTags(this.winRef.nativeWindow.document.body.childNodes, 0),
        a = t / 10;
        for (var i = 0; i < n.length; i++)
        if (this.myObjName = n[i].nodeName,"#text" != this.myObjName && "HTML" != this.myObjName && "HEAD" != this.myObjName && "TITLE" != this.myObjName && "STYLE" != this.myObjName && "SCRIPT" != this.myObjName && "BR" != this.myObjName && "TBODY" != this.myObjName && "#comment" != this.myObjName && "FORM" != this.myObjName && "NOSCRIPT" != this.myObjName) {
          if ("INPUT" == this.myObjName) continue;
            this.styleSize = parseInt(window.getComputedStyle(n[i], null).fontSize), 
            isNaN(this.styleSize) && 
            n[i].currentStyle && 
            (this.styleSize = parseInt(n[i].currentStyle.fontSize)), 
            isNaN(this.styleSize) && 
            (this.styleSize = this.startStyleSize), 
            (this.styleSize > this.minStyleSize && 
             this.styleSize < this.maxStyleSize || this.styleSize == this.minStyleSize && t > 0 || this.styleSize == this.maxStyleSize && 0 > t) 
            && (this.newStyleSize = this.styleSize + a * this.styleSize, n[i].style.fontSize = this.newStyleSize + this.measureUnit)
        }
      }
    } catch (l) { }
    $('.jcarousel-control-next').addClass('inactive');
  }

  resetFonSize() {
    if (this.winRef.nativeWindow.document.body) {
      var e = this.searchTags(this.winRef.nativeWindow.document.body.childNodes, 0);
      for (var i = 0; i < e.length; i++)
      if (this.myObjName = e[i].nodeName,"#text" != this.myObjName && "HTML" != this.myObjName && "HEAD" != this.myObjName && "TITLE" != this.myObjName && "STYLE" != this.myObjName && "SCRIPT" != this.myObjName && "BR" != this.myObjName && "TBODY" != this.myObjName && "#comment" != this.myObjName && "FORM" != this.myObjName && "NOSCRIPT" != this.myObjName) {
        if ("INPUT" == this.myObjName) continue;
          e[i].style.fontSize = ""
      }
    }
    $('.jcarousel-control-next').addClass('inactive');
  }

  searchTags(e:any, t:any) {
    for (var n = new Array, a = new Array, l = 0, i = "", r = 0; r < e.length; r++)
      if (i = e[r].nodeName, e[r].hasChildNodes())
        if (1 == e[r].childNodes.length && "#text" == e[r].childNodes[0].nodeName) n[l++] = e[r];
        else {
          a = this.searchTags(e[r].childNodes, t + 1);
          for (var o = 0; o < a.length; o++) n[l++] = a[o];
          n[l++] = e[r]
        } else n[l++] = e[r];
    return n
  }
  incfont(){
    $("#fontPlus").addClass('active');
    $("#fontMinus").removeClass('active');
    $("#fontNormal").removeClass('active');
    this.increaseFontSize(1,1);
  }  
  decfont(){
    $("#fontMinus").addClass('active');
    $("#fontPlus").removeClass('active');
    $("#fontNormal").removeClass('active');
    this.decreaseFontSize(-1, -1);
  }
  resetSize(){
    $("#fontNormal").addClass('active');
    $("#fontMinus").removeClass('active');
    $("#fontPlus").removeClass('active');
    this.resetFonSize();
  }
}
